
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.6382 14.2923C16.8255 12.761 17.3851 10.8346 17.2031 8.90518C17.0211 6.97574 16.1111 5.18815 14.6584 3.90605C13.2057 2.62396 11.3193 1.94369 9.38294 2.00363C7.44662 2.06358 5.60586 2.85923 4.23514 4.22872C2.86323 5.59917 2.06529 7.44137 2.00394 9.37993C1.94259 11.3185 2.62244 13.2075 3.90496 14.662C5.18747 16.1165 6.97612 17.0271 8.90642 17.2081C10.8367 17.3892 12.7634 16.827 14.2938 15.6363L14.3347 15.6792L18.3738 19.7208C18.4622 19.8093 18.5673 19.8795 18.6829 19.9274C18.7984 19.9753 18.9223 20 19.0474 20C19.1725 20 19.2964 19.9753 19.412 19.9274C19.5276 19.8795 19.6326 19.8093 19.7211 19.7208C19.8096 19.6323 19.8797 19.5273 19.9276 19.4116C19.9755 19.296 20.0001 19.1721 20.0001 19.0469C20.0001 18.9218 19.9755 18.7978 19.9276 18.6822C19.8797 18.5666 19.8096 18.4615 19.7211 18.373L15.6811 14.3323C15.6672 14.3186 15.6529 14.3052 15.6382 14.2923ZM13.6615 5.57657C14.1991 6.10568 14.6267 6.73605 14.9195 7.43129C15.2124 8.12654 15.3647 8.87291 15.3678 9.62736C15.3709 10.3818 15.2246 11.1294 14.9374 11.827C14.6502 12.5246 14.2278 13.1584 13.6946 13.6919C13.1613 14.2254 12.5277 14.648 11.8304 14.9353C11.1331 15.2226 10.3858 15.3689 9.63163 15.3658C8.87748 15.3628 8.1314 15.2103 7.43643 14.9174C6.74146 14.6244 6.11135 14.1967 5.58245 13.6589C4.52547 12.5841 3.93583 11.1351 3.94197 9.62736C3.94811 8.11966 4.54952 6.67546 5.61521 5.60934C6.6809 4.54323 8.12453 3.94158 9.63163 3.93544C11.1387 3.9293 12.5872 4.51917 13.6615 5.57657Z","fill":"#FD5105"}})])
          )
        }
      }
    